// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   Checkbox,
//   FormControlLabel,
//   Grid,
//   Typography,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   FormGroup,
//   FormLabel,
//   Paper,
//   Radio,
//   RadioGroup,
// } from "@mui/material";
// import SaveButton from "components/buttonsComponent/SaveButton";
// import { List, ListItem, IconButton } from "@mui/material";

// import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import UserIdButton from "components/buttonsComponent/UserIdButton";
// import ReportCountdownButton from "components/buttonsComponent/ReportCountdownButton";

// const DownloadReport = ({
//   onNext,
//   onPrevious,
//   ReportDownloadButtonShow = true,
//   uploadEvidenceFieldsShow = false,
//   NextButtonShow = true,
//   initialItems = [],
//   showReportCountdownButton = false,
//   title = "Download the report relevant to your requirements",
//   downloadFileName = "Report_Downloaded.docx",
//   formImageUrl = "../../assets/images/GriCustomizeForm.png",
//   showSaveButton = true,
//   showDragIcon = true,
//   customInputPlaceholder = "Mention name",
//   customInputTriggerLabel = "Any other relevant report",
//   buttonStyles = {},
//   titleStyles = {},
// }) => {
//   const [isDownloadEnabled, setIsDownloadEnabled] = useState(false);
//   const [stepCount, setStepCount] = useState(0);
//   const [items, setItems] = useState(initialItems);
//   const [isDownloaded, setIsDownloaded] = useState(false);
//   const [formData, setFormData] = useState({});

//   const defaultItems = [
//     { label: "Analysis against Performance on GRI Standards Progress" },
//     { label: "Gap Analysis and Action Report (Table)" },
//     { label: "GRI Standards Cross-References" },
//     { label: "Industry Benchmark Score" },
//     { label: "Risk/Opportunity Heatmap" },
//     { label: "Full ESG GRI Progress Report" },
//     { label: "Any other relevant report", checked: false, customName: "" },
//   ];

//   useEffect(() => {
//     if (initialItems.length === 0) {
//       setItems(defaultItems);
//     }
//   }, [initialItems]);

//   useEffect(() => {
//     const atLeastOneChecked = items.some(
//       (item) =>
//         item.checked ||
//         formData[item.label] ||
//         (item.options &&
//           item.options.some((opt) => formData[`${item.label}_${opt}`]))
//     );
//     setIsDownloadEnabled(atLeastOneChecked);
//   }, [items, formData]);

//   const handleNext = () => {
//     setStepCount((prev) => prev + 1);
//     if (onNext) {
//       onNext({ items, formData });
//     }
//   };

//   useEffect(() => {
//     if (!Array.isArray(initialItems) || initialItems.length === 0) {
//       setItems(defaultItems);
//     } else {
//       setItems(initialItems);
//     }
//   }, [initialItems]);

//   const handleToggle = (index) => {
//     const updatedItems = [...items];
//     updatedItems[index].checked = !updatedItems[index].checked;
//     setItems(updatedItems);
//   };

//   const handleFormDataChange = (key, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//   };

//   const handleCheckboxGroupChange = (itemLabel, option, checked) => {
//     const key = `${itemLabel}_${option}`;
//     setFormData((prev) => ({
//       ...prev,
//       [key]: checked,
//     }));
//   };

//   const handleNestedCheckboxChange = (
//     parentLabel,
//     parentOption,
//     childOption,
//     checked
//   ) => {
//     const key = `${parentLabel}_${parentOption}_${childOption}`;
//     setFormData((prev) => ({
//       ...prev,
//       [key]: checked,
//     }));
//   };

//   const handleFileUpload = (event, itemLabel) => {
//     const file = event.target.files[0];
//     if (file) {
//       setFormData((prev) => ({
//         ...prev,
//         [itemLabel]: file,
//       }));
//     }
//   };

//   const handleDownloadClick = () => {
//     const link = document.createElement("a");
//     link.href = formImageUrl;
//     link.download = downloadFileName;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);

//     setIsDownloaded(true);
//     setTimeout(() => setIsDownloaded(false), 2000);
//   };

//   const renderFormField = (item, idx) => {
//     switch (item.type) {
//       case "text":
//         return (
//           <TextField
//             fullWidth
//             placeholder={`Enter ${item.label}`}
//             size="small"
//             value={formData[item.label] || ""}
//             onChange={(e) => handleFormDataChange(item.label, e.target.value)}
//             sx={{ mt: 1 }}
//           />
//         );

//       case "dropdown":
//         return (
//           <FormControl fullWidth size="small" sx={{ mt: 1 }}>
//             <Select
//               value={formData[item.label] || ""}
//               onChange={(e) => handleFormDataChange(item.label, e.target.value)}
//               displayEmpty
//             >
//               <MenuItem value="">
//                 <em>Select {item.label}</em>
//               </MenuItem>
//               {item.options?.map((option, optIdx) => (
//                 <MenuItem key={optIdx} value={option}>
//                   {option}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         );

//       case "nested-dropdown":
//         const selectedOption = formData[item.label];
//         const selectedOptionData = item.options?.find(
//           (opt) => opt.value === selectedOption
//         );

//         return (
//           <Box sx={{ mt: 1 }}>
//             <FormControl fullWidth size="small">
//               <Select
//                 value={formData[item.label] || ""}
//                 onChange={(e) =>
//                   handleFormDataChange(item.label, e.target.value)
//                 }
//                 displayEmpty
//               >
//                 <MenuItem value="">
//                   <em>Select {item.label}</em>
//                 </MenuItem>
//                 {item.options?.map((option, optIdx) => (
//                   <MenuItem key={optIdx} value={option.value}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {selectedOption && selectedOptionData?.subOptions && (
//               <Box sx={{ mt: 2, ml: 2, p: 2, borderRadius: 1 }}>
//                 <Typography
//                   sx={{
//                     fontFamily: "DM Sans",
//                     fontWeight: 600,
//                     fontSize: "14px",
//                     color: "#02462E",
//                     mb: 1,
//                   }}
//                 >
//                   {selectedOptionData.label} - Select applicable items:
//                 </Typography>
//                 <FormGroup>
//                   {selectedOptionData.subOptions.map((subOption, subIdx) => (
//                     <FormControlLabel
//                       key={subIdx}
//                       control={
//                         <Checkbox
//                           checked={
//                             !!formData[
//                               `${item.label}_${selectedOption}_${subOption}`
//                             ]
//                           }
//                           onChange={(e) =>
//                             handleNestedCheckboxChange(
//                               item.label,
//                               selectedOption,
//                               subOption,
//                               e.target.checked
//                             )
//                           }
//                           sx={{
//                             color: "#02462E",
//                             "&.Mui-checked": { color: "#02462E" },
//                           }}
//                         />
//                       }
//                       label={
//                         <Typography
//                           sx={{
//                             fontFamily: "DM Sans",
//                             fontWeight: 400,
//                             fontSize: "13px",
//                             lineHeight: "20px",
//                             color: formData[
//                               `${item.label}_${selectedOption}_${subOption}`
//                             ]
//                               ? "#02462E"
//                               : "#A3AED0",
//                           }}
//                         >
//                           {subOption}
//                         </Typography>
//                       }
//                     />
//                   ))}
//                 </FormGroup>
//               </Box>
//             )}
//           </Box>
//         );

//       case "checkbox":
//         return (
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={!!formData[item.label]}
//                 onChange={(e) =>
//                   handleFormDataChange(item.label, e.target.checked)
//                 }
//                 sx={{
//                   color: "#02462E",
//                   "&.Mui-checked": { color: "#02462E" },
//                 }}
//               />
//             }
//             label={
//               <Typography
//                 sx={{
//                   fontFamily: "DM Sans",
//                   fontWeight: 700,
//                   fontSize: "16px",
//                   lineHeight: "28px",
//                   letterSpacing: "-2%",
//                   color: formData[item.label] ? "#02462E" : "#A3AED0",
//                 }}
//               >
//                 {item.label}
//               </Typography>
//             }
//           />
//         );

//       case "checkbox-group":
//         return (
//           <Box sx={{ mt: 1 }}>
//             <FormLabel component="legend">
//               <Typography
//                 sx={{
//                   fontFamily: "DM Sans",
//                   fontWeight: 700,
//                   fontSize: "16px",
//                   lineHeight: "28px",
//                   color: "#02462E",
//                   mb: 1,
//                 }}
//               >
//                 {item.label}
//               </Typography>
//             </FormLabel>
//             <FormGroup sx={{ ml: 2 }}>
//               {item.options?.map((option, optIdx) => (
//                 <FormControlLabel
//                   key={optIdx}
//                   control={
//                     <Checkbox
//                       checked={!!formData[`${item.label}_${option}`]}
//                       onChange={(e) =>
//                         handleCheckboxGroupChange(
//                           item.label,
//                           option,
//                           e.target.checked
//                         )
//                       }
//                       sx={{
//                         color: "#02462E",
//                         "&.Mui-checked": { color: "#02462E" },
//                       }}
//                     />
//                   }
//                   label={
//                     <Typography
//                       sx={{
//                         fontFamily: "DM Sans",
//                         fontWeight: 500,
//                         fontSize: "14px",
//                         lineHeight: "24px",
//                         color: formData[`${item.label}_${option}`]
//                           ? "#02462E"
//                           : "#A3AED0",
//                       }}
//                     >
//                       {option}
//                     </Typography>
//                   }
//                 />
//               ))}
//             </FormGroup>
//           </Box>
//         );

//       case "radio-group":
//         return (
//           <Box sx={{ mt: 1 }}>
//             <FormLabel component="legend">
//               <Typography
//                 sx={{
//                   fontFamily: "DM Sans",
//                   fontWeight: 700,
//                   fontSize: "16px",
//                   lineHeight: "28px",
//                   color: "#02462E",
//                   mb: 1,
//                 }}
//               >
//                 {item.label}
//               </Typography>
//             </FormLabel>
//             <RadioGroup
//               value={formData[item.label] || ""}
//               onChange={(e) => handleFormDataChange(item.label, e.target.value)}
//               sx={{ ml: 2 }}
//             >
//               {item.options?.map((option, optIdx) => (
//                 <FormControlLabel
//                   key={optIdx}
//                   value={option}
//                   control={
//                     <Radio
//                       sx={{
//                         color: "#02462E",
//                         "&.Mui-checked": { color: "#02462E" },
//                       }}
//                     />
//                   }
//                   label={
//                     <Typography
//                       sx={{
//                         fontFamily: "DM Sans",
//                         fontWeight: 500,
//                         fontSize: "14px",
//                         lineHeight: "24px",
//                         color:
//                           formData[item.label] === option
//                             ? "#02462E"
//                             : "#A3AED0",
//                       }}
//                     >
//                       {option}
//                     </Typography>
//                   }
//                 />
//               ))}
//             </RadioGroup>
//           </Box>
//         );

//       case "upload":
//         return (
//           <Box sx={{ mt: 1 }}>
//             <label htmlFor={`file-input-${idx}`}>
//               <Typography variant="body2" sx={{ mb: 0.5 }}>
//                 {item.label}
//               </Typography>
//             </label>
//             <input
//               id={`file-input-${idx}`}
//               type="file"
//               onChange={(e) => handleFileUpload(e, item.label)}
//               accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
//             />
//             {formData[item.label] && (
//               <Typography
//                 variant="caption"
//                 color="text.secondary"
//                 sx={{ mt: 0.5, display: "block" }}
//               >
//                 Selected: {formData[item.label].name}
//               </Typography>
//             )}
//           </Box>
//         );

//       case "heading":
//         return (
//           <Typography
//             sx={{
//               fontFamily: "DM Sans",
//               fontWeight: 700,
//               fontSize: "17px",
//               lineHeight: "26px",
//               color: "#02462E",
//               px: 1.5,
//               py: 0.75,
//               borderRadius: "6px",
//               mb: 1,
//             }}
//           >
//             {item.label}
//           </Typography>
//         );

//       case "note":
//         return (
//           <Typography
//             sx={{
//               fontFamily: "DM Sans",
//               fontWeight: 400,
//               fontSize: "15px",
//               lineHeight: "24px",
//               color: "#555E75",
//               px: 1.5,
//               py: 0.5,
//               borderRadius: "4px",
//               fontStyle: "italic",
//               mb: 1,
//             }}
//           >
//             {item.label}
//           </Typography>
//         );
//       case "checkbox-with-input":
//         return (
//           <Box sx={{ mt: 1 }}>
//             <FormLabel component="legend">
//               <Typography
//                 sx={{
//                   fontFamily: "DM Sans",
//                   fontWeight: 700,
//                   fontSize: "16px",
//                   lineHeight: "28px",
//                   color: "#02462E",
//                   mb: 1,
//                 }}
//               >
//                 {item.label}
//               </Typography>
//             </FormLabel>
//             <FormGroup sx={{ ml: 2 }}>
//               {item.options?.map((option, optIdx) => {
//                 const checkboxKey = `${item.label}_${option}`;
//                 const inputKey = `${item.label}_${option}_input`;
//                 const isChecked = !!formData[checkboxKey];

//                 return (
//                   <Box key={optIdx} sx={{ mb: 2 }}>
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={isChecked}
//                           onChange={(e) =>
//                             handleCheckboxGroupChange(
//                               item.label,
//                               option,
//                               e.target.checked
//                             )
//                           }
//                           sx={{
//                             color: "#02462E",
//                             "&.Mui-checked": { color: "#02462E" },
//                             alignSelf: "flex-start",
//                             pt: 0.5,
//                           }}
//                         />
//                       }
//                       label={
//                         <Typography
//                           sx={{
//                             fontFamily: "DM Sans",
//                             fontWeight: 500,
//                             fontSize: "14px",
//                             lineHeight: "24px",
//                             color: isChecked ? "#02462E" : "#A3AED0",
//                           }}
//                         >
//                           {option}
//                         </Typography>
//                       }
//                       sx={{ alignItems: "flex-start", mb: 0.5 }}
//                     />
//                     {isChecked && (
//                       <TextField
//                         fullWidth
//                         multiline
//                         rows={2}
//                         placeholder={`Enter observations for ${option}`}
//                         size="small"
//                         value={formData[inputKey] || ""}
//                         onChange={(e) =>
//                           handleFormDataChange(inputKey, e.target.value)
//                         }
//                         sx={{
//                           mt: 0.5,
//                           ml: 4.5,
//                           "& .MuiOutlinedInput-root": {
//                             fontFamily: "DM Sans",
//                             fontSize: "13px",
//                           },
//                         }}
//                       />
//                     )}
//                   </Box>
//                 );
//               })}
//             </FormGroup>
//           </Box>
//         );
//       case "radio-with-input":
//         return (
//           <Box sx={{ mt: 1 }}>
//             <FormLabel component="legend">
//               <Typography
//                 sx={{
//                   fontFamily: "DM Sans",
//                   fontWeight: 700,
//                   fontSize: "16px",
//                   lineHeight: "28px",
//                   color: "#02462E",
//                   mb: 1,
//                 }}
//               >
//                 {item.label}
//               </Typography>
//             </FormLabel>
//             <Box sx={{ ml: 2 }}>
//               {item.options?.map((option, optIdx) => {
//                 const isSelected = formData[item.label] === option;
//                 const inputKey = `${item.label}_${option}_input`;

//                 return (
//                   <Box key={optIdx} sx={{ mb: 2 }}>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "flex-start",
//                         cursor: "pointer",
//                         mb: 0.5,
//                       }}
//                       onClick={() => {
//                         // Toggle: if already selected, unselect it
//                         if (isSelected) {
//                           handleFormDataChange(item.label, "");
//                         } else {
//                           handleFormDataChange(item.label, option);
//                         }
//                       }}
//                     >
//                       <Radio
//                         checked={isSelected}
//                         sx={{
//                           color: "#02462E",
//                           "&.Mui-checked": { color: "#02462E" },
//                           pt: 0.5,
//                         }}
//                       />
//                       <Typography
//                         sx={{
//                           fontFamily: "DM Sans",
//                           fontWeight: 500,
//                           fontSize: "14px",
//                           lineHeight: "24px",
//                           color: isSelected ? "#02462E" : "#A3AED0",
//                           pt: 1,
//                           pl: 1,
//                         }}
//                       >
//                         {option}
//                       </Typography>
//                     </Box>
//                     {isSelected && (
//                       <TextField
//                         fullWidth
//                         multiline
//                         rows={2}
//                         placeholder={`Enter details for ${option}`}
//                         size="small"
//                         value={formData[inputKey] || ""}
//                         onChange={(e) =>
//                           handleFormDataChange(inputKey, e.target.value)
//                         }
//                         sx={{
//                           mt: 0.5,
//                           ml: 4.5,
//                           "& .MuiOutlinedInput-root": {
//                             fontFamily: "DM Sans",
//                             fontSize: "13px",
//                           },
//                         }}
//                       />
//                     )}
//                   </Box>
//                 );
//               })}
//             </Box>
//           </Box>
//         );
//       default:
//         return (
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={item.checked || false}
//                 onChange={() => handleToggle(idx)}
//                 sx={{
//                   color: "#02462E",
//                   "&.Mui-checked": { color: "#02462E" },
//                 }}
//               />
//             }
//             label={
//               <Typography
//                 sx={{
//                   fontFamily: "DM Sans",
//                   fontWeight: 700,
//                   fontSize: "16px",
//                   lineHeight: "28px",
//                   letterSpacing: "-2%",
//                   color: item.checked ? "#02462E" : "#A3AED0",
//                 }}
//               >
//                 {item.label}
//               </Typography>
//             }
//           />
//         );
//     }
//   };

//   const defaultButtonStyles = {
//     download: {
//       background: isDownloadEnabled
//         ? "linear-gradient(180deg, #02462E 0%, #02462E 100%)"
//         : "#D3D3D3",
//       width: "252px",
//       height: "50px",
//       color: "#fff",
//       border: "none",
//       textTransform: "none",
//       fontFamily: "DM Sans",
//       fontWeight: 600,
//       fontSize: "13px",
//       lineHeight: "1.2",
//       cursor: isDownloadEnabled ? "pointer" : "not-allowed",
//       padding: "8px 12px",
//     },
//     next: {
//       background: "linear-gradient(180deg, #02462E 0%, #02462E 100%)",
//       width: "252px",
//       height: "50px",
//       borderRadius: "10px",
//       color: "#fff",
//       textTransform: "none",
//       fontFamily: "DM Sans",
//       fontWeight: 600,
//       fontSize: "16px",
//       "&:hover": {
//         background: "linear-gradient(180deg, #02462E 0%, #02462E 100%)",
//       },
//     },
//   };

//   const defaultTitleStyles = {
//     fontFamily: "DM Sans",
//     fontWeight: 800,
//     fontSize: "24px",
//     lineHeight: "42px",
//     color: "#02462E",
//     mb: 2,
//   };

//   const mergedButtonStyles = {
//     download: { ...defaultButtonStyles.download, ...buttonStyles.download },
//     next: { ...defaultButtonStyles.next, ...buttonStyles.next },
//   };

//   const mergedTitleStyles = { ...defaultTitleStyles, ...titleStyles };

//   return (
//     <Grid container spacing={2}>
//       <Grid item xs={12}>
//         <Box
//           className="standards-header"
//           sx={{
//             display: "flex",
//             justifyContent: "flex-end",
//             alignItems: "center",
//             flexWrap: "wrap",
//             gap: 2,
//             [(theme) => theme.breakpoints.down("sm")]: {
//               justifyContent: "center",
//               flexDirection: "column",
//               alignItems: "stretch",
//             },
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 2,
//               alignItems: "center",
//             }}
//           >
//             {showReportCountdownButton && <ReportCountdownButton />}
//             {showSaveButton && (
//               <SaveButton
//               // onClick={handleSave}
//               >
//                 Save
//               </SaveButton>
//             )}
//             <UserIdButton />
//           </Box>
//         </Box>
//       </Grid>

//       <Grid item xs={12}>
//         <Box
//           sx={{
//             p: 3,
//             maxWidth: "100%",
//           }}
//         >
//           <Typography variant="h6" sx={mergedTitleStyles}>
//             {title}
//           </Typography>

//           <List disablePadding>
//             {items.map((item, idx) => (
//               <ListItem
//                 key={idx}
//                 disableGutters
//                 secondaryAction={
//                   showDragIcon && (
//                     <IconButton edge="end" size="small">
//                       <DragIndicatorIcon fontSize="small" />
//                     </IconButton>
//                   )
//                 }
//                 sx={{ py: 0.5, alignItems: "flex-start" }}
//               >
//                 <Box sx={{ width: "100%" }}>
//                   {renderFormField(item, idx)}

//                   {/* Custom input logic for legacy support */}
//                   {item.label === customInputTriggerLabel && item.checked && (
//                     <TextField
//                       placeholder={customInputPlaceholder}
//                       size="small"
//                       fullWidth
//                       sx={{ mt: 1 }}
//                       value={item.customValue || ""}
//                       onChange={(e) =>
//                         handleFormDataChange(
//                           `${item.label}_custom`,
//                           e.target.value
//                         )
//                       }
//                     />
//                   )}
//                 </Box>
//               </ListItem>
//             ))}
//           </List>

//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "flex-end",
//               gap: 2,
//               mt: 3,
//             }}
//           >
//             {ReportDownloadButtonShow && (
//               <Button
//                 variant="outlined"
//                 disabled={!isDownloadEnabled}
//                 onClick={handleDownloadClick}
//                 style={mergedButtonStyles.download}
//               >
//                 Download Reports
//               </Button>
//             )}
//             {uploadEvidenceFieldsShow && (
//               <Button
//                 variant="outlined"
//                 disabled={!isDownloadEnabled}
//                 onClick={handleDownloadClick}
//                 style={mergedButtonStyles.download}
//               >
//                 upload field observations, Evidences
//               </Button>
//             )}

//             {NextButtonShow && (
//               <Button
//                 variant="contained"
//                 onClick={handleNext}
//                 sx={mergedButtonStyles.next}
//               >
//                 Next
//               </Button>
//             )}
//           </Box>
//         </Box>
//       </Grid>
//     </Grid>
//   );
// };

// export default DownloadReport;

import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormGroup,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import SaveButton from "components/buttonsComponent/SaveButton";
import { List, ListItem, IconButton } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import UserIdButton from "components/buttonsComponent/UserIdButton";
import ReportCountdownButton from "components/buttonsComponent/ReportCountdownButton";

const DownloadReport = ({
  onNext,
  onPrevious,
  ReportDownloadButtonShow = true,
  uploadEvidenceFieldsShow = false,
  NextButtonShow = true,
  initialItems = [],
  showReportCountdownButton = false,
  title = "Download the report relevant to your requirements",
  // description = "", // Added this prop for descriptions
  downloadFileName = "Report_Downloaded.docx",
  formImageUrl = "../../assets/images/GriCustomizeForm.png",
  showSaveButton = true,
  showDragIcon = true,
  customInputPlaceholder = "Mention name",
  customInputTriggerLabel = "Any other relevant report",
  buttonStyles = {},
  titleStyles = {},
}) => {
  const [isDownloadEnabled, setIsDownloadEnabled] = useState(false);
  const [stepCount, setStepCount] = useState(0);
  const [items, setItems] = useState(initialItems);
  const [isDownloaded, setIsDownloaded] = useState(false);
  const [formData, setFormData] = useState({});

  const defaultItems = [
    { label: "Analysis against Performance on GRI Standards Progress" },
    { label: "Gap Analysis and Action Report (Table)" },
    { label: "GRI Standards Cross-References" },
    { label: "Industry Benchmark Score" },
    { label: "Risk/Opportunity Heatmap" },
    { label: "Full ESG GRI Progress Report" },
    { label: "Any other relevant report", checked: false, customName: "" },
  ];

  useEffect(() => {
    if (initialItems.length === 0) {
      setItems(defaultItems);
    }
  }, [initialItems]);

  useEffect(() => {
    const atLeastOneChecked = items.some(
      (item) =>
        item.checked ||
        formData[item.label] ||
        (item.options &&
          item.options.some((opt) => formData[`${item.label}_${opt}`]))
    );
    setIsDownloadEnabled(atLeastOneChecked);
  }, [items, formData]);

  const handleNext = () => {
    setStepCount((prev) => prev + 1);
    if (onNext) {
      onNext({ items, formData });
    }
  };

  useEffect(() => {
    if (!Array.isArray(initialItems) || initialItems.length === 0) {
      setItems(defaultItems);
    } else {
      setItems(initialItems);
    }
  }, [initialItems]);

  const handleToggle = (index) => {
    const updatedItems = [...items];
    updatedItems[index].checked = !updatedItems[index].checked;
    setItems(updatedItems);
  };

  const handleFormDataChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleCheckboxGroupChange = (itemLabel, option, checked) => {
    const key = `${itemLabel}_${option}`;
    setFormData((prev) => ({
      ...prev,
      [key]: checked,
    }));
  };

  const handleNestedCheckboxChange = (
    parentLabel,
    parentOption,
    childOption,
    checked
  ) => {
    const key = `${parentLabel}_${parentOption}_${childOption}`;
    setFormData((prev) => ({
      ...prev,
      [key]: checked,
    }));
  };

  const handleFileUpload = (event, itemLabel) => {
    const file = event.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        [itemLabel]: file,
      }));
    }
  };

  const handleDownloadClick = () => {
    const link = document.createElement("a");
    link.href = formImageUrl;
    link.download = downloadFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setIsDownloaded(true);
    setTimeout(() => setIsDownloaded(false), 2000);
  };

  // Updated renderFormField with new cases
  const renderFormField = (item, idx) => {
    switch (item.type) {
      case "text":
        return (
          <TextField
            fullWidth
            placeholder={`Enter ${item.label}`}
            size="small"
            value={formData[item.label] || ""}
            onChange={(e) => handleFormDataChange(item.label, e.target.value)}
            sx={{ mt: 1 }}
          />
        );

      case "textarea":
        return (
          <TextField
            fullWidth
            multiline
            rows={item.rows || 4}
            placeholder={item.placeholder || `Enter ${item.label}`}
            size="small"
            value={formData[item.label] || ""}
            onChange={(e) => handleFormDataChange(item.label, e.target.value)}
            required={item.required}
            sx={{ mt: 1 }}
          />
        );

      case "dropdown":
        return (
          <FormControl fullWidth size="small" sx={{ mt: 1 }}>
            <Select
              value={formData[item.label] || ""}
              onChange={(e) => handleFormDataChange(item.label, e.target.value)}
              displayEmpty
            >
              <MenuItem value="">
                <em>Select {item.label}</em>
              </MenuItem>
              {item.options?.map((option, optIdx) => (
                <MenuItem key={optIdx} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );

      case "nested-dropdown":
        const selectedOption = formData[item.label];
        const selectedOptionData = item.options?.find(
          (opt) => opt.value === selectedOption
        );

        return (
          <Box sx={{ mt: 1 }}>
            <FormControl fullWidth size="small">
              <Select
                value={formData[item.label] || ""}
                onChange={(e) =>
                  handleFormDataChange(item.label, e.target.value)
                }
                displayEmpty
              >
                <MenuItem value="">
                  <em>Select {item.label}</em>
                </MenuItem>
                {item.options?.map((option, optIdx) => (
                  <MenuItem key={optIdx} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {selectedOption && selectedOptionData?.subOptions && (
              <Box sx={{ mt: 2, ml: 2, p: 2, borderRadius: 1 }}>
                <Typography
                  sx={{
                    fontFamily: "DM Sans",
                    fontWeight: 600,
                    fontSize: "14px",
                    color: "#02462E",
                    mb: 1,
                  }}
                >
                  {selectedOptionData.label} - Select applicable items:
                </Typography>
                <FormGroup>
                  {selectedOptionData.subOptions.map((subOption, subIdx) => (
                    <FormControlLabel
                      key={subIdx}
                      control={
                        <Checkbox
                          checked={
                            !!formData[
                              `${item.label}_${selectedOption}_${subOption}`
                            ]
                          }
                          onChange={(e) =>
                            handleNestedCheckboxChange(
                              item.label,
                              selectedOption,
                              subOption,
                              e.target.checked
                            )
                          }
                          sx={{
                            color: "#02462E",
                            "&.Mui-checked": { color: "#02462E" },
                          }}
                        />
                      }
                      label={
                        <Typography
                          sx={{
                            fontFamily: "DM Sans",
                            fontWeight: 400,
                            fontSize: "13px",
                            lineHeight: "20px",
                            color: formData[
                              `${item.label}_${selectedOption}_${subOption}`
                            ]
                              ? "#02462E"
                              : "#A3AED0",
                          }}
                        >
                          {subOption}
                        </Typography>
                      }
                    />
                  ))}
                </FormGroup>
              </Box>
            )}
          </Box>
        );

      case "checkbox":
        return (
          <FormControlLabel
            control={
              <Checkbox
                checked={!!formData[item.label]}
                onChange={(e) =>
                  handleFormDataChange(item.label, e.target.checked)
                }
                sx={{
                  color: "#02462E",
                  "&.Mui-checked": { color: "#02462E" },
                }}
              />
            }
            label={
              <Typography
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: formData[item.label] ? "#02462E" : "#A3AED0",
                }}
              >
                {item.label}
              </Typography>
            }
          />
        );

      case "checkbox-group":
        return (
          <Box sx={{ mt: 1 }}>
            <FormLabel component="legend">
              <Typography
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "28px",
                  color: "#02462E",
                  mb: 1,
                }}
              >
                {item.label}
              </Typography>
              {/* {item.description && (
                <Typography sx={{ fontSize: "12px", color: "#A3AED0", mb: 1 }}>
                  {item.description}
                </Typography>
              )} */}
            </FormLabel>
            <FormGroup sx={{ ml: 2 }}>
              {item.options?.map((option, optIdx) => (
                <FormControlLabel
                  key={optIdx}
                  control={
                    <Checkbox
                      checked={!!formData[`${item.label}_${option}`]}
                      onChange={(e) =>
                        handleCheckboxGroupChange(
                          item.label,
                          option,
                          e.target.checked
                        )
                      }
                      sx={{
                        color: "#02462E",
                        "&.Mui-checked": { color: "#02462E" },
                      }}
                    />
                  }
                  label={
                    <Typography
                      sx={{
                        fontFamily: "DM Sans",
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "24px",
                        color: formData[`${item.label}_${option}`]
                          ? "#02462E"
                          : "#A3AED0",
                      }}
                    >
                      {option}
                    </Typography>
                  }
                />
              ))}
            </FormGroup>
            {item.display && (
              <Typography sx={{ mt: 1, fontSize: "12px", color: "#555E75" }}>
                {item.display}
              </Typography>
            )}
          </Box>
        );

      case "radio-group":
        return (
          <Box sx={{ mt: 1 }}>
            <FormLabel component="legend">
              <Typography
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "28px",
                  color: "#02462E",
                  mb: 1,
                }}
              >
                {item.label}
              </Typography>
            </FormLabel>
            <RadioGroup
              value={formData[item.label] || ""}
              onChange={(e) => handleFormDataChange(item.label, e.target.value)}
              sx={{ ml: 2 }}
            >
              {item.options?.map((option, optIdx) => (
                <FormControlLabel
                  key={optIdx}
                  value={option}
                  control={
                    <Radio
                      sx={{
                        color: "#02462E",
                        "&.Mui-checked": { color: "#02462E" },
                      }}
                    />
                  }
                  label={
                    <Typography
                      sx={{
                        fontFamily: "DM Sans",
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "24px",
                        color:
                          formData[item.label] === option
                            ? "#02462E"
                            : "#A3AED0",
                      }}
                    >
                      {option}
                    </Typography>
                  }
                />
              ))}
            </RadioGroup>
          </Box>
        );

      case "upload":
        return (
          <Box sx={{ mt: 1 }}>
            <label htmlFor={`file-input-${idx}`}>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                {item.label}
              </Typography>
            </label>
            <input
              id={`file-input-${idx}`}
              type="file"
              onChange={(e) => handleFileUpload(e, item.label)}
              accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
            />
            {formData[item.label] && (
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mt: 0.5, display: "block" }}
              >
                Selected: {formData[item.label].name}
              </Typography>
            )}
          </Box>
        );

      case "heading":
        return (
          <Typography
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 700,
              fontSize: "17px",
              lineHeight: "26px",
              color: "#02462E",
              px: 1.5,
              py: 0.75,
              borderRadius: "6px",
              mb: 1,
            }}
          >
            {item.label}
          </Typography>
        );

      case "note":
        return (
          <Typography
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 400,
              fontSize: "15px",
              lineHeight: "24px",
              color: "#555E75",
              px: 1.5,
              py: 0.5,
              borderRadius: "4px",
              fontStyle: "italic",
              mb: 1,
            }}
          >
            {item.label}
          </Typography>
        );

      case "checkbox-with-input":
        return (
          <Box sx={{ mt: 1 }}>
            <FormLabel component="legend">
              <Typography
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "28px",
                  color: "#02462E",
                  mb: 1,
                }}
              >
                {item.label}
              </Typography>
            </FormLabel>
            <FormGroup sx={{ ml: 2 }}>
              {item.options?.map((option, optIdx) => {
                const checkboxKey = `${item.label}_${option}`;
                const inputKey = `${item.label}_${option}_input`;
                const isChecked = !!formData[checkboxKey];

                return (
                  <Box key={optIdx} sx={{ mb: 2 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isChecked}
                          onChange={(e) =>
                            handleCheckboxGroupChange(
                              item.label,
                              option,
                              e.target.checked
                            )
                          }
                          sx={{
                            color: "#02462E",
                            "&.Mui-checked": { color: "#02462E" },
                            alignSelf: "flex-start",
                            pt: 0.5,
                          }}
                        />
                      }
                      label={
                        <Typography
                          sx={{
                            fontFamily: "DM Sans",
                            fontWeight: 500,
                            fontSize: "14px",
                            lineHeight: "24px",
                            color: isChecked ? "#02462E" : "#A3AED0",
                          }}
                        >
                          {option}
                        </Typography>
                      }
                      sx={{ alignItems: "flex-start", mb: 0.5 }}
                    />
                    {isChecked && (
                      <TextField
                        fullWidth
                        multiline
                        rows={2}
                        placeholder={`Enter observations for ${option}`}
                        size="small"
                        value={formData[inputKey] || ""}
                        onChange={(e) =>
                          handleFormDataChange(inputKey, e.target.value)
                        }
                        sx={{
                          mt: 0.5,
                          ml: 4.5,
                          "& .MuiOutlinedInput-root": {
                            fontFamily: "DM Sans",
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                  </Box>
                );
              })}
            </FormGroup>
          </Box>
        );

      case "radio-with-input":
        return (
          <Box sx={{ mt: 1 }}>
            <FormLabel component="legend">
              <Typography
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "28px",
                  color: "#02462E",
                  mb: 1,
                }}
              >
                {item.label}
              </Typography>
            </FormLabel>
            <Box sx={{ ml: 2 }}>
              {item.options?.map((option, optIdx) => {
                const isSelected = formData[item.label] === option;
                const inputKey = `${item.label}_${option}_input`;

                return (
                  <Box key={optIdx} sx={{ mb: 2 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        cursor: "pointer",
                        mb: 0.5,
                      }}
                      onClick={() => {
                        // Toggle: if already selected, unselect it
                        if (isSelected) {
                          handleFormDataChange(item.label, "");
                        } else {
                          handleFormDataChange(item.label, option);
                        }
                      }}
                    >
                      <Radio
                        checked={isSelected}
                        sx={{
                          color: "#02462E",
                          "&.Mui-checked": { color: "#02462E" },
                          pt: 0.5,
                        }}
                      />
                      <Typography
                        sx={{
                          fontFamily: "DM Sans",
                          fontWeight: 500,
                          fontSize: "14px",
                          lineHeight: "24px",
                          color: isSelected ? "#02462E" : "#A3AED0",
                          pt: 1,
                          pl: 1,
                        }}
                      >
                        {option}
                      </Typography>
                    </Box>
                    {isSelected && (
                      <TextField
                        fullWidth
                        multiline
                        rows={2}
                        placeholder={`Enter details for ${option}`}
                        size="small"
                        value={formData[inputKey] || ""}
                        onChange={(e) =>
                          handleFormDataChange(inputKey, e.target.value)
                        }
                        sx={{
                          mt: 0.5,
                          ml: 4.5,
                          "& .MuiOutlinedInput-root": {
                            fontFamily: "DM Sans",
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                  </Box>
                );
              })}
            </Box>
          </Box>
        );

      case "section-header":
        return (
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="h5"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 700,
                fontSize: "18px",
                lineHeight: "28px",
                color: "#02462E",
                mb: 1,
              }}
            >
              {item.label}
            </Typography>
            {/* {item.description && (
              <Typography
                sx={{ fontSize: "14px", color: "#555E75", fontStyle: "italic" }}
              >
                {item.description}
              </Typography>
            )} */}
          </Box>
        );

      case "weighted-scorecard":
        const weightFields = item.fields?.map((f) => f.label) || [];
        const weights = weightFields.map(
          (key) => parseFloat(formData[key]) || 0
        );
        const totalWeight = weights.reduce((a, b) => a + b, 0);
        const summaryText =
          item.summary?.display?.replace(/__/g, () => {
            return weights.shift() || 0;
          }) || `Total: ${totalWeight}%`;

        return (
          <Box
            sx={{ mt: 1, p: 2, border: "1px solid #E0E0E0", borderRadius: 1 }}
          >
            <Typography
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 700,
                fontSize: "16px",
                color: "#02462E",
                mb: 2,
              }}
            >
              {item.label}
            </Typography>
            <Grid container spacing={2}>
              {item.fields?.map((field, fIdx) => (
                <Grid item xs={12} sm={6} key={fIdx}>
                  <TextField
                    fullWidth
                    label={field.label}
                    placeholder={field.placeholder}
                    type="number"
                    size="small"
                    value={formData[field.label] || ""}
                    onChange={(e) =>
                      handleFormDataChange(field.label, e.target.value)
                    }
                    inputProps={{
                      min: field.validation?.min || 0,
                      max: field.validation?.max || 100,
                    }}
                    sx={{
                      "& .MuiInputLabel-root": {
                        fontSize: "13px",
                        color: "#555E75",
                      },
                      "& .MuiInputLabel-root.Mui-focused": {
                        color: "#02462E",
                      },
                      "& .MuiOutlinedInput-root": {
                        color: "#02462E",
                        fontSize: "14px",
                      },
                      "& .MuiOutlinedInput-root fieldset": {
                        borderColor: "#D0D5DD",
                      },
                      "& .MuiOutlinedInput-root:hover fieldset": {
                        borderColor: "#02462E",
                      },
                    }}
                  />
                </Grid>
              ))}
            </Grid>
            <Typography
              sx={{
                mt: 2,
                fontSize: "12px",
                color: totalWeight === 100 ? "#02462E" : "#ff9800",
                fontStyle: "italic",
              }}
            >
              {summaryText} {totalWeight !== 100 && `(Total: ${totalWeight}%)`}
            </Typography>
          </Box>
        );

      case "auto-flags":
        return (
          <Box
            sx={{ mt: 1, p: 2, border: "1px solid #E0E0E0", borderRadius: 1 }}
          >
            <Typography
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 700,
                fontSize: "16px",
                color: "#02462E",
                mb: 1,
              }}
            >
              {item.label}
            </Typography>
            {/* {item.description && (
              <Typography sx={{ fontSize: "12px", color: "#A3AED0", mb: 2 }}>
                {item.description}
              </Typography>
            )} */}
            <FormGroup>
              {item.autoDetectedFlags?.map((flag, fIdx) => (
                <FormControlLabel
                  key={fIdx}
                  control={
                    <Checkbox
                      checked={!!formData[`${item.label}_${flag}`]}
                      onChange={(e) =>
                        handleCheckboxGroupChange(
                          item.label,
                          flag,
                          e.target.checked
                        )
                      }
                      sx={{
                        color: "#02462E",
                        "&.Mui-checked": { color: "#02462E" },
                      }}
                    />
                  }
                  label={flag}
                />
              ))}
            </FormGroup>
            {item.placeholder && (
              <Typography
                sx={{
                  mt: 1,
                  fontSize: "12px",
                  color: "#A3AED0",
                  fontStyle: "italic",
                }}
              >
                e.g., {item.placeholder}
              </Typography>
            )}
          </Box>
        );

      // In your renderFormField function, replace the digital-signature case:

case "digital-signature":
  return (
    <Box
      sx={{ mt: 1, p: 2, border: "1px solid #E0E0E0", borderRadius: 1 }}
    >
      <Typography
        sx={{
          fontFamily: "DM Sans",
          fontWeight: 700,
          fontSize: "16px",
          color: "#02462E",
          mb: 2,
        }}
      >
        {item.label}
      </Typography>
      <Grid container spacing={2}>
        {item.fields?.map((field, fIdx) => (
          <Grid item xs={12} key={fIdx}>
            {field.type === "date" ? (
              <TextField
                fullWidth
                label={field.label}
                type="date"
                size="small"
                value={formData[field.label] || ""}
                onChange={(e) =>
                  handleFormDataChange(field.label, e.target.value)
                }
                required={field.required}
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: "#555E75",
                    fontSize: "13px",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#02462E",
                  },
                  "& .MuiOutlinedInput-root": {
                    color: "#02462E",
                    fontSize: "14px",
                  },
                  "& .MuiOutlinedInput-root fieldset": {
                    borderColor: "#D0D5DD",
                  },
                  "& .MuiOutlinedInput-root:hover fieldset": {
                    borderColor: "#02462E",
                  },
                }}
              />
            ) : field.type === "signature-pad" ? (
              <Box
                sx={{
                  border: "1px dashed #02462E",
                  p: 2,
                  textAlign: "center",
                  mt: 1,
                }}
              >
                <Typography sx={{ color: "#02462E", mb: 1 }}>
                  {field.placeholder}
                </Typography>
                <Button variant="outlined" size="small">
                  Sign Here
                </Button>
              </Box>
            ) : (
              <TextField
                fullWidth
                label={field.label}
                placeholder={field.placeholder}
                size="small"
                value={formData[field.label] || ""}
                onChange={(e) =>
                  handleFormDataChange(field.label, e.target.value)
                }
                required={field.required}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: "#555E75",
                    fontSize: "13px",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#02462E",
                  },
                  "& .MuiOutlinedInput-root": {
                    color: "#02462E",
                    fontSize: "14px",
                  },
                  "& .MuiOutlinedInput-root fieldset": {
                    borderColor: "#D0D5DD",
                  },
                  "& .MuiOutlinedInput-root:hover fieldset": {
                    borderColor: "#02462E",
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#555E75",
                  },
                }}
              />
            )}
          </Grid>
        ))}
      </Grid>
    </Box>
  );

      default:
        return (
          <FormControlLabel
            control={
              <Checkbox
                checked={item.checked || false}
                onChange={() => handleToggle(idx)}
                sx={{
                  color: "#02462E",
                  "&.Mui-checked": { color: "#02462E" },
                }}
              />
            }
            label={
              <Typography
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: item.checked ? "#02462E" : "#A3AED0",
                }}
              >
                {item.label}
              </Typography>
            }
          />
        );
    }
  };

  const defaultButtonStyles = {
    download: {
      background: isDownloadEnabled
        ? "#02462E"
        : "#D3D3D3",
      width: "252px",
      height: "50px",
      color: "#fff",
      border: "none",
      textTransform: "none",
      fontFamily: "DM Sans",
      fontWeight: 600,
      fontSize: "13px",
      lineHeight: "1.2",
      cursor: isDownloadEnabled ? "pointer" : "not-allowed",
      padding: "8px 12px",
    },
    next: {
      background: "#02462E",
      width: "252px",
      height: "50px",
      borderRadius: "10px",
      color: "#fff",
      textTransform: "none",
      fontFamily: "DM Sans",
      fontWeight: 600,
      fontSize: "16px",
      "&:hover": {
        background: "#02462E",
      },
    },
  };

  const defaultTitleStyles = {
    fontFamily: "DM Sans",
    fontWeight: 800,
    fontSize: "24px",
    lineHeight: "42px",
    color: "#02462E",
    mb: 2,
  };

  const mergedButtonStyles = {
    download: { ...defaultButtonStyles.download, ...buttonStyles.download },
    next: { ...defaultButtonStyles.next, ...buttonStyles.next },
  };

  const mergedTitleStyles = { ...defaultTitleStyles, ...titleStyles };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box
          className="standards-header"
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
            [(theme) => theme.breakpoints.down("sm")]: {
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "stretch",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              alignItems: "center",
            }}
          >
            {showReportCountdownButton && <ReportCountdownButton />}
            {showSaveButton && (
              <SaveButton
              // onClick={handleSave}
              >
                Save
              </SaveButton>
            )}
            <UserIdButton />
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box
          sx={{
            p: 3,
            maxWidth: "100%",
          }}
        >
          <Typography variant="h6" sx={mergedTitleStyles}>
            {title}
          </Typography>
          {/* {description && (
            <Typography sx={{ fontSize: "14px", color: "#555E75", mb: 2 }}>
              {description}
            </Typography>
          )} */}

          <List disablePadding>
            {items.map((item, idx) => (
              <ListItem
                key={idx}
                disableGutters
                secondaryAction={
                  showDragIcon && (
                    <IconButton edge="end" size="small">
                      <DragIndicatorIcon fontSize="small" />
                    </IconButton>
                  )
                }
                sx={{ py: 0.5, alignItems: "flex-start" }}
              >
                <Box sx={{ width: "100%" }}>
                  {renderFormField(item, idx)}

                  {/* Custom input logic for legacy support */}
                  {item.label === customInputTriggerLabel && item.checked && (
                    <TextField
                      placeholder={customInputPlaceholder}
                      size="small"
                      fullWidth
                      sx={{ mt: 1 }}
                      value={item.customValue || ""}
                      onChange={(e) =>
                        handleFormDataChange(
                          `${item.label}_custom`,
                          e.target.value
                        )
                      }
                    />
                  )}
                </Box>
              </ListItem>
            ))}
          </List>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 3,
            }}
          >
            {ReportDownloadButtonShow && (
              <Button
                variant="outlined"
                disabled={!isDownloadEnabled}
                onClick={handleDownloadClick}
                style={mergedButtonStyles.download}
              >
                Download Reports
              </Button>
            )}
            {uploadEvidenceFieldsShow && (
              <Button
                variant="outlined"
                disabled={!isDownloadEnabled}
                onClick={handleDownloadClick}
                style={mergedButtonStyles.download}
              >
                upload field observations, Evidences
              </Button>
            )}

            {NextButtonShow && (
              <Button
                variant="contained"
                onClick={handleNext}
                sx={mergedButtonStyles.next}
              >
                Next
              </Button>
            )}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DownloadReport;
